import React from 'react';
import type { LatestProjectStatus } from '../../types/latestProjects';
import { latestStatusLabel } from '../../utils/latestProjects';
const styles: Record<LatestProjectStatus, string> = {
  ongoing: 'bg-brand-action text-white',
  completed: 'bg-white text-charcoal',
  pending: 'border border-review/70 text-review'
};
export function StatusBadge({
  status
}: {
  status: LatestProjectStatus;
}) {
  return <span className={`inline-flex h-6 items-center gap-1.5 px-2.5 font-display text-[12px] font-bold uppercase tracking-[0.12em] ${styles[status]}`} data-id="element-325" data-mp="mhampsxc4kf5">
      {status === 'ongoing' && <span className="h-1.5 w-1.5 rounded-full bg-white" aria-hidden="true" data-id="element-326" data-mp="cil603h6d60h" />}
      <span className="sr-only" data-id="element-327" data-mp="hgwcc489gydy">Status: </span>
      {latestStatusLabel(status)}
    </span>;
}